import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { push, back } from 'redux-first-router';

import { setFocusedClock } from 'actions/gallery';

import Portal from 'components/Portal';

import Device from './Device';
import SelectedClocks from './SelectedClocks';
import ClockDetails from './ClockDetails';
import { sortFavoriteClockfaces } from '../../../components/v2/MyApps/util';

const DEVICE_RENAME = {
  'inspire hr': 'inspire'
};

const FullDiv = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
`;

const MainContainer = styled(FullDiv)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background-color: #f5f5f5;
`;

const DeviceWrapper = styled.div`
  margin-top: auto;
  margin-bottom: auto;

  height: 200px;
`;

const DeviceOverlayLink = styled(FullDiv)`
  z-index: 1;
`;

class MyClocks extends Component {
  componentDidMount() {
    // Used to capture when back button is pressed
    window.onhashchange = () => {
      const { focusedClock, setFocusedClock } = this.props;

      const { hash } = window.location;

      if (focusedClock && hash === '#/clocks') {
        setFocusedClock(null);
      }
    };
  }

  componentWillUnmount() {
    window.onhashchange = null;
  }

  get device() {
    const { currentUser: { device = {} } = {} } = this.props;

    return device;
  }

  get deviceName() {
    const deviceName = this.device.productName.toLowerCase();
    return DEVICE_RENAME[deviceName] || deviceName;
  }

  get favoriteClocksEnabled() {
    return (
      this.props.flags.enableFavoriteClockfaces && this.maxFavoriteClocks > 0
    );
  }

  get maxFavoriteClocks() {
    return this.device.maxFavoriteClocks;
  }

  get maxClocks() {
    return this.device.maxInstalledClocks;
  }

  get activeClock() {
    const { apps } = this.props;

    if (apps.length === 1) {
      return apps[0];
    }

    const selectedClock = apps.find(({ isSelected }) => isSelected);

    if (selectedClock) {
      return selectedClock;
    }

    return apps.find(({ active }) => active) || {};
  }

  get favoriteClocks() {
    return this.props.favorites;
  }

  get focusedClock() {
    const { apps, favorites = [], focusedClock } = this.props;

    const allApps = [...apps, ...favorites];

    return allApps.find(({ id }) => id === focusedClock);
  }

  renderDeviceOverlayLink() {
    return (
      <DeviceOverlayLink
        data-my-clocks-open-selected-clock
        onClick={() => this.props.setFocusedClock(this.activeClock.id)}
        id="active-clock-image"
      />
    );
  }

  renderDevice() {
    return (
      <DeviceWrapper>
        <Device clock={this.activeClock} deviceName={this.deviceName} />
      </DeviceWrapper>
    );
  }

  render() {
    const focusedClock = this.focusedClock;
    const firstClock = sortFavoriteClockfaces(
      this.favoriteClocks,
      this.activeClock
    )[0];
    let isFirstClock = false;
    if (firstClock && focusedClock) {
      isFirstClock = firstClock.id === focusedClock.id;
    }

    return (
      <MainContainer
        data-my-clocks-selected-id={this.activeClock.id}
        data-my-clocks-selected-name={this.activeClock.name}
      >
        {this.renderDevice()}
        {this.renderDeviceOverlayLink()}
        {this.favoriteClocksEnabled && (
          <SelectedClocks
            maxFavoriteClocks={this.maxFavoriteClocks}
            favoriteClocks={this.favoriteClocks}
            deviceName={this.deviceName}
            activeClock={this.activeClock}
            setFocusedClock={this.props.setFocusedClock}
          />
        )}
        <Portal
          id="focusedClock"
          content={
            <ClockDetails
              show={!!focusedClock}
              clock={focusedClock}
              deviceName={this.deviceName}
              favoriteClocksEnabled={this.favoriteClocksEnabled}
              favoriteClocksCount={this.favoriteClocks.length}
              installedClocksCount={this.props.apps.length}
              maxFavoriteClocks={this.maxFavoriteClocks}
              setFocusedClock={this.props.setFocusedClock}
              isFirstClock={isFirstClock}
            />
          }
        />
      </MainContainer>
    );
  }
}

const mapStateToProps = ({ gallery, registry }) => ({
  focusedClock: gallery.focusedClock,
  selectedClock: gallery.selectedClock,
  flags: registry.features.flags
});

const mapDispatchToProps = (dispatch) => ({
  setFocusedClock(clockId) {
    dispatch(setFocusedClock(clockId));
    clockId ? push('/clocks?focused') : back();
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(MyClocks);
